export default {
  banner: {
    title: 'Mapping Software Builder',
    items: [
      'Develop industry-leading productivity tools for clients',
      'Provide production process improvement services based on productivity tools',
      'Facilitate smart geographic data factory construction through production process improvement'
    ]
  },
  login: {
    title: 'Account Password Login',
    scanTitle: 'QR Code Login',
    codeTitle: 'Phone Login',
    logIn: 'Login',
    register: 'Register',
    username: 'Username',
    password: 'Password',
    rule: 'Username Or Tel',
    version: 'V',
    upper: 'Caps locked',
    scanTip: 'APP Scan code login',
    accountTip: 'Please enter the account number',
    passwordTip: 'Please enter your password',
    codeTip: 'Please enter your verification code',
    changeCode: 'Click to switch verification code',
    mobile: 'Please enter mobile number',
    rightMobile: 'Please enter the correct mobile number',
    smsCode: 'Please enter the verification code',
    getCode: 'Get code',
    reSend: 'Resend',
    company: 'Please enter company name',
    contacts: 'Please enter contact',
    ForgetPassword: 'Forgot Password',
    confirmPassword: 'Please confirm password',
    newPassword: 'Please enter new password',
    confirmNewPassword: 'Please confirm new password',
    sendSuccess: 'Sent successfully',
    loginFailed: 'Login failed',
    secondsResend: 's to resend',
    resendCode: 'Resend code',
    firstScanTip: 'Tip: First time scan login requires binding phone number.',
    submit: 'Submit',
  },
  home: {
    productIntro: 'Innovative Solutions • Empowering Industry Scenario Implementation',
    Industry: 'Industry Applications',
    productAdvantage: 'Why Choose Summit',
    productAdvantageintroDes: 'Core product advantages',
    getServices: 'Obtain the latest Summit series products and services',
    clickButton: 'clickButton',
    toolPlatform: 'Spatial data processing tool platform',
    ViewDetails: 'ViewDetails',
    IPR: 'Independent intellectual property rights',
    patent: 'invention patent',
    Ratio: 'Ratio of R&D personnel',
    requirement: "Let's discuss your project planning",
    solutions: 'We provide professional solutions',
  },
  product: {
    Features: 'function characteristics',
    function: 'function Comparison',
    Competitor: 'Competitor Comparison',
    otherFlag: 'otherFlag',
    ourFlag: 'ourFlag',
    vs: 'Summit vs similar products',
  },
  Buy: {
    // 顶部区域
    priceSectionTitle: "Select Your Subscription Product",

    // 产品卡片
    hotTag: "Hot",
    buyNow: "Buy Now",
    DownloadNow: "Download",
    learnMore: "Learn More",

    // 定价方案
    contactSales: "Contact Sales",
    perWeek: "/week",
    freeUse: "Free",
    freeTrialTag: "Free Trial",
    coreFeatures: "Core Features",

    // 功能对比
    featureComparison: "Feature Comparison",

    // 系统配置
    SystemConfiguration: "System Configuration",
    operatingSystem: "Operating System",
    entryConfig: "Standard Configuration",
    recommend: "Recommended",
    recommendConfig: "Recommended Configuration",

    // 订阅指南
    subscribeGuide: "Subscription Guide",
    noContent: "No content available",
    loadFailed: "Loading failed, please try again",

    // 常见问题
    faqTitle: "FAQ",
    faqSubtitle: "Find answers quickly",

    // 提示消息
    selectProductFirst: "Please select products first",
  },
  message: {
    sendSuccess: 'Send successfully',
    deleteSuccess: 'Delete successfully',
    saveSuccess: 'Save successfully'
  },
  menu: {
    home: 'Home',
    products: 'Products',
    buy: 'Subscription',
    freeSoft: 'FreeSoftware',
    service: 'Support',
    about: 'About Us',
    customerService: 'Customer Service',
    cart: 'Cart',

    titles: {
      SummitMap: 'One-stop intelligent image generation platform',
      SummitSolid: 'One-stop monomer system',
      SummitLab: 'Intelligent interior work training system',
      SummitTerra: 'SummitTerra',
      softwareSupport: 'Software Support',
      qa: 'Q&A',
      contact: 'Contact Us',
      companyIntro: 'Company Introduction',
      culture: 'Corporate Culture',
      honors: 'Honors and Qualifications'
    },

    content: {
      summitMapDesc: 'Point Cloud, Oblique, Stereo Aerial',
      support: 'Tutorial Videos',
      contactInfo: 'Contact Information'
    }
  },
  header: {
    login: 'Login',
    logout: 'Logout',
    userAuth: 'User Verification',
    orderManage: 'Order Management',
    licenseApply: 'License Application',
    invoiceManage: 'Invoice Management',
    invoiceProfile: 'Invoice Info Maintenance'
  },
  guide: {
    entryTip: 'Guide',
    next: 'Next',
    prev: 'Previous',
    done: 'Done',
    goNext: 'Next',
    stepPersonalTitle: 'Step 1: Open Personal Center',
    stepPersonalDesc: 'Click your avatar at the top-right to enter "Personal Center", where you manage orders, licenses and invoices.',
    stepOrderTitle: 'Step 2: Download Purchased Software',
    stepOrderDesc: 'In "Order Management", find the order and click "Download" to get the installer and download links.',
    stepLicenseTitle: 'Step 3: Create a License',
    stepLicenseDesc: 'In "License Application", click "Create License" and follow the prompts with your machine code to generate a license.',
    stepScanTitle: 'Apply for a License by Mobile QR Scan',
    stepScanDesc: 'You can scan the workflow shown below with your phone to complete the license application.',
    stepLicenseMobile: 'You can also do this on your phone — scan the QR code below to continue on mobile:'
  },
  footer: {
    address: 'Address',
    addressValue: 'Floor 2, Building 1, Zone B, Future Technology City, No. 999 Gaoxin Avenue, Wuhan, Hubei',
    phone: 'Phone',
    email: 'Email',
    softwareSupport: 'Software Support',
    qa: 'Q&A',
    customerService: 'Customer Service',
    contactUs: 'Contact Us',
    companyIntro: 'Company Introduction',
    culture: 'Corporate Culture',
    honors: 'Honors & Qualifications',
    companyMap: 'Company Map',
    joinUs: 'Join Us',
    wechatPlatform: 'Official Wechat Channel',
    officialVideo: 'Official Video Channel',
    douyingVideo: 'Official Douyin Channel',
    icp: 'ICP License: 鄂ICP备2022010992号-1'
  },
  Service: {
    // FAQ
    faqTitle: "FAQ",

    // 搜索横幅
    searchBannerTitle: "Welcome to Summitek Service & Support",
    searchPlaceholder: "Enter your question",
    searchButton: "Search",

    // 功能卡片
    videoTitle: "Operation Video",
    downloadTitle: "Downloads",
    allTitle: "All",
    manualTitle: "User Manual",
    newsTitle: "Update Log",
    mediaTitle: "Promo Video",

    // 热点问题
    hotQuestionsTitle: "Hot · Related · Questions",
    viewMore: "View More",

    // 联系我们
    contactUsTitle: "Contact Us",
    contactPhone: "Customer Service Hotline",
    companyAddress: "Address",
    companyAddressValue: "",
    companyAddressValueEn: "",
    email: "Email",
    wechatQrcode: "WeChat",
    qrcodeScan: "Scan QR Code",
    qrcodeServiceTip: "Get Dedicated Customer Service",

    // 反馈表单
    feedbackTitle: "Customer Service · Feedback",
    feedbackSubtitle: "If you have any questions or suggestions, please fill in the form below and we will reply to you as soon as possible",
    nameLabel: "Name",
    namePlaceholder: "Please enter your name",
    nameRequired: "Please enter your name",
    emailLabel: "Email",
    emailPlaceholder: "Please enter your email",
    emailRequired: "Please enter your email",
    emailFormat: "Please enter a valid email address",
    subjectLabel: "Subject",
    subjectPlaceholder: "Please enter the subject",
    subjectRequired: "Please enter the subject",
    contentLabel: "Content",
    contentPlaceholder: "Please describe your question or suggestion in detail...",
    contentRequired: "Please enter the feedback content",
    tip: "* We will reply to you within 1-3 business days",
    submitButton: "Submit Feedback",
    feedbackSuccess: "Feedback submitted successfully, thank you for your valuable comments!",
    feedbackError: "Submission failed, please try again later",
  },

  aboutUs: {
    // Banner区域
    mainTitle: "Mapping Software Builder",
    subTitle: "SUMMITEK LTD.",
    ipRights: "Intellectual Property Rights",
    inventionPatents: "Invention Patents",
    rdRatio: "R&D Personnel Ratio",
    introParagraph1: "Wuhan Summitek Technology was founded in 2020, located in Wuhan Future Science and Technology City, is a high-tech enterprise specializing in the development of domestic spatial data governance platforms",
    introParagraph2: "Based on the self-developed SummitSDK technology system, the company has built three productivity tool software product families: Summit, Lab and Flow, providing exclusive solutions in computing power, surveying, natural resources and other fields for industry users",
    introParagraph3: "Committed to becoming a leader in the spatial data governance software industry, fully empowering geographic information data resources and national major engineering construction",

    // 企业文化
    vision: "Vision",
    visionText: "Mapping Software Builder",
    concept: "Concept",
    conceptText1: "Details Create Products, Service Wins Market",
    conceptText2: "Rules Defines Bottom Line, Culture Sets the Ceiling",  
    mission: "Mission",
    missionText1: "Develop industry-leading productivity tool software for customers",
    missionText2: "Provide production process improvement services based on productivity tool software",
    missionText3: "Help build smart geographic data factories through production process improvement",
    coreValues: "Core Values",
    coreValuesText1: "Everyone through their own efforts",
    coreValuesText2: "Can obtain reasonable remuneration and a dignified life",

    // 荣誉资质
    honorsDesc1: "The company always regards ",
    honorsHighlight1: "independent R&D innovation",
    honorsDesc2: " as the core and soul of high-quality development",
    honorsDesc3: "With ",
    honorsHighlight2: "more than 40 independent intellectual property rights and 11 invention patents",
    honorsDesc4: "Rapidly building its own technology protection system at the speed of ",
    honorsHighlight3: "adding 2-3 invention patents every year",
    honorsDesc5: "",

    // 证书名称
    certSpecialized: "Specialized Enterprise",
    certGazelle: "Optics Valley Gazelle Enterprise",
    certHighTech: "High-tech Enterprise",
    certSoftware: "Software Copyright",
    certPatent: "Invention Patent",
    certSurveyingB: "Class B Surveying and Mapping Qualification",
    certGazelleShort: "Optics Valley Gazelle",
    certQualitySystem: "Quality Management System Certification",
    certWuhanAi: "Wuhan AI Enterprise Database",
    certGisEval: "GIS Software Evaluation Certificate",
    certInnovativeProduct: "Independent Innovation Product in Surveying & GIS",
    certInnovationContest: "Innovation & Entrepreneurship Competition Excellence Award",
    certSoftwareShort: "Software Copyright",
    certHunanGrand: "Hunan Grand Prize",
    certShandongAward: "Shandong Natural Resources Science & Technology Award",
    certSoftwareAssoc: "Provincial Software Association Member",
    certReal3dEval: "Real-scene 3D Evaluation Certificate",

    // 联系我们
    contactUs: "Contact Us",
    contactUsText: "CONTACT US",
  },
  SubscribeDialog: {
    // 时长单位
    durationUnit: "Duration Unit",
    week: "Week",
    month: "Month",
    quarter: "Quarter",
    halfyear: "halfyear",
    recommend: "Recommended",
    only: "Only",
    perDay: "/day",

    // 订阅设置
    subscribeDuration: "Subscription Duration",
    softwareQuantity: "Software Quantity",
    total: "Total",

    // 按钮
    subscribeNow: "Subscribe Now",

    // 协议
    agreementText: "I have read and agree to",
    productAgreement: "Product Subscription Terms",
    licenseAgreement: "Summitek PC Software License Agreement",
    scrollToAgree: "Scroll to bottom to agree",
    haveRead: "I have read",

    // 提示
    pleaseAgreeFirst: "Please read and agree to the agreements first",
  },

  OrderConfirmDialog: {
    // 支付成功
    paymentComplete: "Your payment is complete",
    viewInUserCenter: "View in User Center",

    // 收货信息
    receiverInfo: "User Info",
    name: "Name",
    namePlaceholder: "Please enter your name",
    nameRequired: "Please enter your name",
    phone: "Phone",
    phonePlaceholder: "Please enter your phone number",
    phoneRequired: "Please enter your phone number",
    phoneInvalid: "Please enter a valid phone number",
    email: "Email",
    emailPlaceholder: "Please enter your email",
    emailRequired: "Please enter your email",
    emailInvalid: "Please enter a valid email address",
    company: "Company",
    companyPlaceholder: "Please enter company name",
    companyRequired: "Please enter company name",
    editUserInfo: "Edit",
    editUserInfoTitle: "Edit User Info",
    userInfoSaveSuccess: "User info saved",
    userInfoSaveFailed: "Save failed, please try again later",

    // 订单信息
    confirmOrderInfo: "Confirm Order Info",
    productInfo: "Product Info",
    productDetail: "Product Detail",
    purchaseDuration: "Duration",
    purchaseQuantity: "Quantity",
    price: "Price",
    inviteCodeDiscount: "Invite Code Discount",

    // 邀请码
    inviteCode: "Invite Code",
    inviteCodePlaceholder: "Enter invite code",
    inviteCodeInvalid: "Invalid invite code",
    inviteCodeSuccess: "Invite code verified, discount applied",
    inviteCodeFailed: "Invite code verification failed",
    inviteCodeChangedNeedReconfirm: "Discount updated. Please click Confirm again to regenerate the payment QR code.",

    // 发票
    invoice: "Invoice",
    needInvoice: "I need an invoice",
    invoiceType: "Invoice Type",
    electronicInvoice: "Electronic Invoice",
    vatInvoice: "VAT Electronic Invoice",
    headerType: "Header Type",
    personal: "Personal",
    enterprise: "Enterprise",
    invoiceHeader: "Invoice Header",
    selectInvoiceHeader: "Select invoice header",
    pleaseSelectInvoiceHeader: "Please select invoice header",

    // 订单备注
    orderRemark: "Order Remark",
    orderRemarkPlaceholder: "Optional, enter order remark",

    // 按钮
    confirm: "Confirm",
    cancel: "Cancel",

    // 付款详情
    paymentDetails: "Payment Details",
    totalProducts: "{count} products in total",
    productTotal: "Product Total",
    total: "Total",

    // 支付
    scanToPay: "Scan to pay",
    scanToPayTip: "Please scan to pay",
    payNow: "Pay Now",
    paying: "Paying...",

    // 支付方式
    alipay: "Alipay",
    wechat: "WeChat",
    unionpay: "UnionPay",
    creditCard: "Credit Card",

    // 提示消息
    orderSuccess: "Order placed, please scan to pay",
    orderFailed: "Order failed",
    orderError: "Order error, please try again",
    getQrcodeFailed: "Failed to get payment QR code, please try again later",
    orderIdMissing: "Order ID missing, please confirm order first",
    paymentCompleted: "Payment completed",
    paymentNotDetected: "Payment not detected, please scan and pay first",
    queryPaymentFailed: "Failed to query payment status",
    payingInProgress: "Payment in progress, please wait",
    missingOrderId: "Missing order ID, please contact support",
  },

  ShoppingCartDialog: {
    // 标题
    title: "Shopping Cart",

    // 列表
    purchaseDuration: "Duration",
    delete: "Delete",

    // 空状态
    emptyCart: "Your cart is empty",

    // 结算
    settlementDetails: "Settlement Details",
    totalProducts: "{count} products",
    total: "Total",
    settle: "Checkout",

    // 时长单位
    week: "week",
    month: "month",
    quarter: "quarter",
    halfyear: "halfyear",
  },
}
